const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee-strip"
      className="relative border-y border-[#CBD3DF] bg-[#F2F5F9] py-5 overflow-hidden marquee-mask"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span
            key={i}
            className="font-display font-semibold uppercase tracking-[0.25em] text-base text-neutral-600 flex items-center"
          >
            <span className="px-8">{item}</span>
            <span className="text-emerald/60 text-xs">///</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
